/*
import React, { useEffect, useState } from 'react';
import './normalize.css';
import { pay } from "../../actions/checkout";
import { connect } from "react-redux";



const PaymentForm = ({pay}) => {
  
  const [errorStack, setErrorStack] = useState([]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://cdn.checkout.com/js/framesv2.min.js";
    script.onload = () => {
      window.Frames.init("pk_sbox_bcafffpmb7orn2yue2an3uk3tmr"); // pk_test_8ac41c0d-fbcc-4ae3-a771-31ea533a2beb
      setupFrames();
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const setupFrames = () => {
    window.Frames.addEventHandler(window.Frames.Events.CARD_VALIDATION_CHANGED, onCardValidationChanged);
    window.Frames.addEventHandler(window.Frames.Events.FRAME_VALIDATION_CHANGED, onValidationChanged);
    window.Frames.addEventHandler(window.Frames.Events.CARD_TOKENIZATION_FAILED, onCardTokenizationFailed);
    window.Frames.addEventHandler(window.Frames.Events.CARD_TOKENIZED, onCardTokenized);
  }

  const [isCardValid, setIsCardValid] = useState(false);

  const onCardValidationChanged = (event) => {
    setIsCardValid(window.Frames.isCardValid());
  };
  const onValidationChanged = (event) => {
    console.log("FRAME_VALIDATION_CHANGED: ", event);

    const hasError = !event.isValid && !event.isEmpty;
    const newErrorStack = [...errorStack];

    if (hasError) {
      newErrorStack.push(event.element);
    } else {
      newErrorStack.filter(element => element !== event.element);
    }

    setErrorStack(newErrorStack);
  };
  const onCardTokenizationFailed = (error) => {
    console.log("CARD_TOKENIZATION_FAILED: ", error);
  };

  const onCardTokenized = (event) => {
    //console.log("Card tokenization completed. Your card token is: ", event);
    pay(event.token); // Calling pay function with token
  };

  const getErrorMessage = (element) => {
    const errors = {
      "card-number": "Please enter a valid card number",
      "expiry-date": "Please enter a valid expiry date",
      cvv: "Please enter a valid cvv code",
    };
    return errors[element];
  };

  const handleSubmit = event => {
    event.preventDefault();
    window.Frames.submitCard();
  };



  return (

    <section className="main-page page-dashboard">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3 border-0 bg-white shadow-sm rounded ">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3 text-center border-box">
                  <h1 className="font-weight-bold m-0"></h1>
                </div>
                
                <div className="margin-left: auto; margin-right: auto;" >
                <div className="rounded-circle overflow-hidden" style={{height: "113px", width: "100%", margin: "0 auto"}}>
                  <img className="img-fluid" src="assets/images/Checkout.com.png"  style={{objectFit: "cover", height: "100%", width: "100%"}} />
                </div>
                {/** <img src="assets/images/Checkout.com.png" 
                className="img-fluid user-pict-img" 
                alt="Cyber2Cyber"  />} 
                <form id="payment-form" method="POST" action="https://merchant.com/charge-card" onSubmit={handleSubmit}>
                    <div className="one-liner">
                      <div className="card-frame"></div>
                      <button id="pay-button" disabled={!isCardValid}>
                        PAY GBP 24.99
                      </button>
                    </div>

                  </form>
                  <div id="paypal-button-container"></div>
                  <p id="result-message"></p>
                  <script src="https://www.paypal.com/sdk/js?client-id=test&currency=USD"></script>
                  <script src="app.js"></script>
                  </div>
              </div>
              
            </div>
          </div>
          </div>
          </div>
          </div>
          

    </section>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps,{pay})(PaymentForm);*/
import React, { Component }  from "react";
import {GoSellElements} from "@tap-payments/gosell";


class GoSellDemo extends Component {

  constructor(props){
    super(props);
  }

  callbackFunc(response){
    console.log(response);
  }

  render() {

    return (
      <div className="App">

        <button onClick={() => GoSellElements.submit()}>Submit</button>

        <GoSellElements
           gateway={{
             publicKey:"pk_test_Y9JeLPbM4SRT08fxwI6vnFQi",  // pk_test_Vlk842B1EA7tDN5QbrfGjYzh     pk_test_Y9JeLPbM4SRT08fxwI6vnFQi
             language:"en",
             contactInfo:true,
             supportedCurrencies:"all",
             supportedPaymentMethods:"all",
             customerCards: true,
             notifications:'standard',
             backgroundImg: {
              url: 'imgURL',
              opacity: '0.5'
            },
             callback: this.callbackFunc,
             labels:{
                 cardNumber:"Card Number",
                 expirationDate:"MM/YY",
                 cvv:"CVV",
                 cardHolder:"Name on Card",
                 actionButton:"Pay"
             },
             style: {
                 base: {
                   color: '#535353',
                   lineHeight: '18px',
                   fontFamily: 'sans-serif',
                   fontSmoothing: 'antialiased',
                   fontSize: '16px',
                   '::placeholder': {
                     color: 'rgba(0, 0, 0, 0.26)',
                     fontSize:'15px'
                   }
                 },
                 invalid: {
                   color: 'red',
                   iconColor: '#fa755a '
                 }
             }
           }}
           customer={{
             first_name: "First Name",
             middle_name: "Middle Name",
             last_name: "Last Name",
             email: "demo@email.com"
           }}
           order={{
             amount: 100,
             currency:"SAR",
             items:null,
             shipping:null,
             taxes: null
           }}
           transaction={{
            mode: 'charge',
            charge: {
              redirect: "http://localhost:3000/checkout",
              post: null,
            }
          }}
           />
      </div>
    );
  }
}

export default GoSellDemo;

  
  